import { Typography } from "@mui/material";

function Lost() {
  return (
    <Typography variant="h6">
      This is not the page you are looking for
    </Typography>
  );
}

export default Lost;
